import React from "react";
import styled from "styled-components";
import {widgetBorderColour} from "../../../../style/styleConsts";

import WidgetHeader from "./WidgetHeader";
import GroupingRows from "./GroupingRows";
import ViewAndSubdivideButton from "./ViewAndSubdivideButton";
import NotAvailableMessage from "./NotAvailableMessage";

const WidgetContainer = styled.div`
    display: flex;
    flex-direction: column;
    
    width: 100%;
    height: 365px;
    border-radius: 6px;
    outline: none;
    border: 1px solid ${widgetBorderColour};
`;

const GroupingWidget = ({
                            grouping,
                            title,
                            className,
                            currency,
                            selectedKpi,
                            isPrimary = false,
                            onViewClick,
                            onExportClick,
                            exploreUrl,
                            exportUrl,
                            count,
                            limit = 15,
                            showRank,
                            rowLinkGenerator
                        }) => {
    return (
        <WidgetContainer className={className}>
            <WidgetHeader title={title}
                          isPrimary={isPrimary}
                          count={count}
                          onExportClick={onExportClick}
                          exportUrl={exportUrl}/>
            <WidgetBody grouping={grouping} limit={limit} currency={currency} selectedKpi={selectedKpi}
                        showRank={showRank} rowLinkGenerator={rowLinkGenerator} onViewClick={onViewClick}
                        exploreUrl={exploreUrl}/>
        </WidgetContainer>
    );
};

const WidgetBody = ({grouping, limit, currency, selectedKpi, showRank, rowLinkGenerator, onViewClick, exploreUrl}) => {
    if (!grouping) {
        return <NotAvailableMessage/>;
    }

    return (
        <>
            <GroupingRows grouping={grouping}
                          key="groupingRows"
                          currency={currency}
                          selectedKpi={selectedKpi}
                          limit={limit}
                          showRank={showRank}
                          rowLinkGenerator={rowLinkGenerator}/>
            <ViewAndSubdivideButton onViewClick={onViewClick}
                                    url={exploreUrl}
                                    key="viewAndSubdivideButton"/>
        </>
    )
};

export default GroupingWidget;
